import React, { useState } from 'react';
import { SprayChart as NyySprayChart, RESULT_TYPES, LiveFilterPills, getResultTooltip } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import { useMultiVideoFn, usePitchVideoFn } from '../../../../data';
import { VideoPlayerModal } from '../../../../components/VideoPlayer';

const series = [{
    hitmonResultType: 1,
    color: '#0000ff',
    marker: { symbol: 'diamond', radius: 4, lineColor: '#0000ff', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
}, {
    hitmonResultType: 2,
    color: '#0000ff',
    marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
}, {
    hitmonResultType: 7,
    color: '#ffa500',
    marker: { symbol: 'diamond', radius: 4, lineColor: '#ffa500', fillColor: '#ffffff', lineWidth: 2, states: { hover: { radiusPlus: 10 } } },
}, {
    hitmonResultType: 8,
    color: '#ffa500',
    marker: { symbol: 'triangle', radius: 5, states: { hover: { radiusPlus: 10, lineWidth: 2, lineColor: '#fff' } } },
}];

const getSeries = (pitches, filter, translate) => series.filter((s) => filter.includes(s.hitmonResultType)).map((s) => ({
    ...s,
    id: s.hitmonResultType,
    name: RESULT_TYPES(translate).find((rt) => rt.id === s.hitmonResultType).name,
    data: pitches.filter((p) => p.hitmonresulttype === s.hitmonResultType).map((p) => ({
        x: p.ballinplayx,
        y: p.ballinplayy,
        bip: p.bip,
        ballinplayx: p.ballinplayx,
        ballinplayy: p.ballinplayy,
        islastpitch: p.islastpitch,
        exitvelo: p.exitvelo,
        launchangle: p.launchangle,
        gameid: p.gameid,
        eventseq: p.eventseq,
        pitchseq: p.pitchseq,
    })),
}));
const SprayChart = ({ isLhb, pitches }) => {
    const { t: translate } = useTranslation();
    const pitchVideoFn = usePitchVideoFn();
    const multiVideoFn = useMultiVideoFn();

    const [filter, setFilter] = useState(series.map((s) => s.hitmonResultType));

    const options = RESULT_TYPES(translate).filter((rt) => series.some((s) => s.hitmonResultType === rt.id));

    const filterdPitches = pitches.filter((p) => !!p.bip);

    const tooltipFormatter = (s, point) => {
        const pitch = filterdPitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);
        if (!pitch) return '';
        return getResultTooltip(s.name, pitch, translate);
    };

    return (
        <ReportCard
            title={`${translate('pitcher-overview.sections.spray-chart')} 
                    ${translate('baseball.abbr-versus')} 
                    ${isLhb ? translate('baseball.lhh') : translate('baseball.rhh')}`}
        >
            <div className="text-center">
                <div className="mx-auto my-2" style={{ maxWidth: 750 }}>
                    <LiveFilterPills filter={filter} setFilter={setFilter} options={options} />
                </div>
                <NyySprayChart
                    type="outfield"
                    seriesData={getSeries(filterdPitches, filter, translate)}
                    pitchVideoFn={pitchVideoFn}
                    multiVideoFn={multiVideoFn}
                    videoPlayerModal={VideoPlayerModal}
                    tooltipFormatter={tooltipFormatter}
                />
            </div>
        </ReportCard>
    );
};

export default SprayChart;
